import { AssignmentType } from 'types/assignment';

export enum EAssignedTypes {
    DATE_TIME = 'exact_time',
    TIME = 'relative_ol',
    NOW = 'now',
    RELATIVE_LS_END = 'relative_ls_end',
    AFTER_MATERIALS_VIEWED = 'after_materials_viewed',
    AFTER_EXERCISES_COMPLETED = 'after_exercises_completed',
}
export enum EDeadlineTypes {
    DATE_TIME = 'exact_time',
    TIME = 'relative_assigned',
    UNTIL_NEXT_OL = 'until_next_ol',
    UNTIL_SELECTED_OL = 'until_selected_ol',
}
export enum EDurationTypes {
    UNLIMITED = 'unlimited',
    TIME_LIMITED = 'time_limited',
}
export interface Task {
    id: number;
    title: string;
    type?: AssignmentType;
    isTemplate: boolean;
    isForMethodist?: boolean;
    isPosted?: boolean;
    assignedDate?: string;
    assignedDelay?: number;
    deadlineForComplete?: string;
    deadlineDelay?: number;
    timeToComplete?: number;
    assignedType: EAssignedTypes;
    deadlineType: EDeadlineTypes;
    teacher?: number;
    allStudents?: boolean;
    newStudents?: boolean;
}
export type TTaskFormValue = {
    assignedType?: EAssignedTypes;
    assignedDate?: string;
    assignedDelay?: number;
    deadlineType?: EDeadlineTypes;
    deadlineForComplete?: string;
    deadlineDelay?: number;
    deadlineLesson?: number;
    timeToComplete?: number;
    teacher?: number;
};
